import { render, staticRenderFns } from "./CancelarStatusModal.vue?vue&type=template&id=6fc36d79&scoped=true"
import script from "./CancelarStatusModal.vue?vue&type=script&lang=js"
export * from "./CancelarStatusModal.vue?vue&type=script&lang=js"
import style0 from "./CancelarStatusModal.vue?vue&type=style&index=0&id=6fc36d79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc36d79",
  null
  
)

export default component.exports